import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ToggleSwitch from '../../../../../common/inputs/toggleSwitch/ToggleSwitch'
import { TextInput } from '../../../../../common/inputs/textInput/TextInput'
import { useAppSelector } from '../../../../../../app/hooks'
import { InitState } from '../../../../../../redux/reducers/root/initialState'
import { ContentStateProperty } from '../../../../../../@types/types'
import { isWebView } from '../../../../../../utils/navigation'

const fieldId = 'phone-number'

export interface PhoneNumberProps {
  disabled?: boolean
  phoneNumber?: string
  phoneNumberValidation: string[]
  onChange: (property: ContentStateProperty, value: string | boolean | undefined) => void
}

const PhoneNumberWithToggleSwitch: React.FC<PhoneNumberProps> = ({
  phoneNumber,
  phoneNumberValidation,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation()
  const [hasPhoneNumber, setHasPhoneNumber] = useState<boolean>(
    !isWebView() && phoneNumber !== undefined && phoneNumber !== null && phoneNumber !== ''
  )
  const { phoneNumber: phoneNumberFromUser } = useAppSelector((state: InitState) => state.userFeature)

  const doToggle = (value: boolean) => {
    setHasPhoneNumber(value)

    if (value) {
      onChange('phoneNumber', phoneNumberFromUser)
    } else {
      onChange('phoneNumber', undefined)
    }
  }

  return (
    <>
      {hasPhoneNumber && (
        <div className='grid one-whole margin-top-l float-right'>
          <TextInput
            disabled={disabled}
            id='phone-number'
            propertyName='phoneNumber'
            className='one-whole margin-bottom-s grid-item'
            type='tel'
            label={t('wizard.screen.contactInfo.labels.phoneNumber', 'Phone Number')}
            value={phoneNumber}
            errors={phoneNumberValidation}
            maxLength={40}
            doOnFieldChange={(property, value) => onChange(property, value !== '' ? value : undefined)}
          />
        </div>
      )}
      <div className='grid one-whole margin-top-l float-right'>
        <div>
          <ToggleSwitch
            id={`${fieldId}-toggle`}
            data-testid='phone-number-toggle'
            alignment='maxSpread'
            className=''
            togglePlacement={isWebView() ? 'full' : 'right'}
            propertyName='custom'
            label={<span>{t('wizard.screen.contactInfo.labels.addPhoneNumberField', 'show phone number')}</span>}
            value={hasPhoneNumber}
            onChange={(_, value) => doToggle(value)}
          />
        </div>
      </div>
    </>
  )
}

export default PhoneNumberWithToggleSwitch
